// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__24NhD","ToolBar":"Toolbar_ToolBar__1k8qB","Logo":"Toolbar_Logo__3AGXq","DesktopOnly":"Toolbar_DesktopOnly__CitsQ"};